import { IdentityHostname } from './identity';
import type { Environment } from './interface';

export const prod: Environment = {
  apiBusinessGqlUrl: 'https://business-center.pipelinersales.com/api/business/graphql',
  apiCustomerGqlOrigin: `https://customer-portal.${IdentityHostname}`,
  apiUserGqlUrl: `https://api.${IdentityHostname}/api/user/graphql`,
  apiSchedulerGqlUrl: 'https://api.pipelinersales.com/api/scheduler/public/graphql',
  apiOnlineFormGqlUrl: 'https://api.pipelinersales.com/api/online-form/public/graphql',
  apiPublicGqlUrl: 'https://api.pipelinersales.com/api/public/graphql',
  businessCenterUrl: 'https://business-center.pipelinersales.com',
  customerPortalUrl: 'https://customer-portal.pipelinersales.com',
  partnerPortalUrl: 'https://partner-portal.pipelinersales.com',
  crmUrl: `https://crm.${IdentityHostname}`,
  schedulerUrl: `https://scheduler.pipelinersales.com`,
  signUpUrl: 'https://pipelinersales.com/crm/free-trial/',
  ssoUrl: 'https://accounts.pipelinersales.com',
  formsUrl: `https://forms.pipelinersales.com`
};
